import { z } from 'zod';

export const registerSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: z.string().min(8, 'Password must be at least 8 characters'),
  fullName: z.string().min(1, 'Full name is required'),
  orgName: z.string().min(1, 'Organization name is required'),
});

export type RegisterInput = z.infer<typeof registerSchema>;

export const loginSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: z.string().min(1, 'Password is required'),
});

export type LoginInput = z.infer<typeof loginSchema>;

export const refreshTokenSchema = z.object({
  refreshToken: z.string().min(1, 'Refresh token is required'),
});

export type RefreshTokenInput = z.infer<typeof refreshTokenSchema>;

export const googleAuthSchema = z.object({
  idToken: z.string().min(1, 'Google ID token is required'),
});

export type GoogleAuthInput = z.infer<typeof googleAuthSchema>;

export const facebookAuthSchema = z.object({
  accessToken: z.string().min(1, 'Facebook access token is required'),
});

export type FacebookAuthInput = z.infer<typeof facebookAuthSchema>;

export const onboardingSchema = z.object({
  industry: z.enum(['IT_WEB', 'DESIGN', 'CONTENT', 'CONSULTING', 'OTHER']).optional(),
  teamSize: z.enum(['SOLO', 'SMALL', 'MEDIUM']).optional(),
  preferredChannel: z.enum(['ZALO', 'EMAIL', 'BOTH']).optional(),
  defaultCurrency: z.enum(['VND', 'USD', 'BOTH']).optional(),
  taxCategory: z.enum(['DISTRIBUTION', 'SERVICE', 'PRODUCTION', 'OTHER', 'RENTAL']).nullable().optional(),
});

export type OnboardingInput = z.infer<typeof onboardingSchema>;

export const inviteMemberSchema = z.object({
  email: z.string().email('Invalid email address'),
  role: z.enum(['ADMIN', 'MEMBER']).default('MEMBER'),
});

export type InviteMemberInput = z.infer<typeof inviteMemberSchema>;

export const acceptInviteSchema = z.object({
  token: z.string().min(1, 'Invitation token is required'),
  fullName: z.string().min(1, 'Full name is required').optional(),
  password: z.string().min(8, 'Password must be at least 8 characters').optional(),
});

export type AcceptInviteInput = z.infer<typeof acceptInviteSchema>;

export const updateMemberRoleSchema = z.object({
  role: z.enum(['ADMIN', 'MEMBER']),
});

export type UpdateMemberRoleInput = z.infer<typeof updateMemberRoleSchema>;
